import React from 'react';
import { PropTypes } from 'prop-types';
import { Button } from '@unite-us/ui';
import Dialog from '../../components/modal/Dialog';
export function DeleteReferralModal(_ref) {
  var refModal = _ref.refModal,
    onCloseModal = _ref.onCloseModal,
    referral = _ref.referral,
    onDeleteSelectedReferral = _ref.onDeleteSelectedReferral;
  var closeDialog = function closeDialog() {
    onCloseModal();
  };
  var deleteReferral = function deleteReferral() {
    onDeleteSelectedReferral();
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Dialog, {
    onCloseModal: closeDialog,
    onRequestClose: closeDialog,
    ref: refModal,
    title: "Delete",
    customSize: {
      width: '400px'
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "h-24"
  }, /*#__PURE__*/React.createElement("p", null, "Are you sure you want to delete this referral?")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-end"
  }, /*#__PURE__*/React.createElement(Button, {
    id: "cancel",
    onClick: closeDialog,
    label: "Cancel",
    className: "mr-4",
    primary: true
  }), /*#__PURE__*/React.createElement(Button, {
    id: "delete",
    onClick: deleteReferral,
    label: "Delete",
    className: "",
    primary: true
  }))))));
}
;
DeleteReferralModal.propTypes = {
  refModal: PropTypes.func.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  referral: PropTypes.object.isRequired
};
export default DeleteReferralModal;
//# sourceMappingURL=DeleteReferralModal.js.map